import * as vp from 'vopay';
import { FunctionComponent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MultiplePaymentMethodsDialogue.module.scss';
import MiniModal from '../../../../UI/MiniModal/MiniModal';
import MultiplePaymentMethodsForm from './MultiplePaymentMethodsForm';
import { usePaylink } from '../../../../../providers/Paylink.provider';

const { Box } = vp;

type MultiplePaymentMethodsDialogueProps = {
  onClose: () => void;
  defaultValues: {
    Amount: string;
    MaximumAmount: string;
  };
  onSave: (Amount: string) => void;
  show: boolean;
  totalAmount: string;
  remainingAmount: string;
};

type FC = FunctionComponent<MultiplePaymentMethodsDialogueProps>;

const MultiplePaymentMethodsDialogue: FC = ({
  show,
  onClose,
  onSave,
  defaultValues,
  totalAmount,
  remainingAmount,
}: MultiplePaymentMethodsDialogueProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'MultiplePaymentMethods' });
  const { paylink } = usePaylink();
  return useMemo(
    () => (
      <MiniModal
        show={show}
        title={<>{t('enterAmount')}</>}
        content={
          <Box flx="col" gap="lg" base="8">
            <Box r="md" gapSize="4px" flx="col" p="md" background="grey">
              <div className={styles.totalTitle}>{`${t('total')}`}</div>
              <Box gapSize="10px" flx="col">
                <div className={styles.totalAmount}>
                  {paylink.Currency} {vp.formattedCurrency(totalAmount)}
                </div>
                <div className={styles.totalRemaining}>
                  {`${t('remaining')}`} {paylink.Currency}{' '}
                  {vp.formattedCurrency(vp.sanitizeToNumeric(remainingAmount) || '')}
                </div>
              </Box>
            </Box>
            <MultiplePaymentMethodsForm
              defaultValues={defaultValues}
              onSave={(values) => {
                onSave(values.Amount);
              }}
            />
          </Box>
        }
        onClose={onClose}
      />
    ),
    [show],
  );
};

export default MultiplePaymentMethodsDialogue;
